import {FormattedMessage, injectIntl} from 'react-intl';
import {Avatar} from 'shared/components';

const StageChangeEntry = ({entry, intl}) => {
  return (
    <div className='flex gap-6 border-top p3'>
      <Avatar employee={entry.user} size='sm' />
      <div>
        <div className='flex items-center gap-2'>
          <div>
            <span className='h3 waterloo pr1'><FormattedMessage id='recruiting.hiring_funnel.CANDIDATE_MOVED_TO' values={{moved: entry.isForward ? intl.formatMessage({id: 'recruiting.hiring_funnel.Advanced'}) : intl.formatMessage({id: 'recruiting.hiring_funnel.Reverted'})}}/></span>
            <span className='h3 medium'>{entry.nextFunnelStageName}</span>
          </div>
          <div className='h5 jumbo'>{entry.date}</div>
        </div>
        <div className='h5 jumbo'>{entry.name}</div>
      </div>
    </div>

  );
};

export default injectIntl(StageChangeEntry);
